export const traitLabels = [
  { key: 'macroVsMicro' as const, label: 'Orientation', leftLabel: 'Micro', rightLabel: 'Macro' },
  { key: 'valueVsGrowth' as const, label: 'Investment Bias', leftLabel: 'Value', rightLabel: 'Growth' },
  { key: 'timeHorizon' as const, label: 'Time Horizon', leftLabel: 'Short-term', rightLabel: 'Long-term' },
  { key: 'passiveVsActive' as const, label: 'Engagement Level', leftLabel: 'Passive', rightLabel: 'Active' },
  { key: 'strategicVsFinancial' as const, label: 'Investment Approach', leftLabel: 'Financial', rightLabel: 'Strategic' },
];

export type TraitKey = (typeof traitLabels)[number]['key'];
export const traitKeys: TraitKey[] = traitLabels.map(({ key }) => key);

